import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { useAuth } from '../contexts/AuthContext';
import { ApiError, classesApi, type SchoolClass } from '../services/api/client';

export default function HomePage() {
  const { user } = useAuth();

  if (!user) return null;

  const isProfessor = user.role === 'PROFESSOR';

  return (
    <>
      <div className="home-cycle" aria-hidden="true">
        <span /><span /><span /><span />
      </div>

      <section className="card card-lead">
        <h2>Bem-vindo</h2>
        <p className="muted">
          Bem-vindos à disciplina de Gestão de Processos. Desejo a todos ótimas
          atividades!
        </p>
        <dl className="info-grid">
          <div>
            <dt>Conta</dt>
            <dd>{user.email}</dd>
          </div>
          <div>
            <dt>Perfil</dt>
            <dd>{isProfessor ? 'Professor' : 'Aluno'}</dd>
          </div>
        </dl>
      </section>

      <ClassesSummary isProfessor={isProfessor} />
    </>
  );
}

function ClassesSummary({ isProfessor }: { isProfessor: boolean }) {
  const [classes, setClasses] = useState<SchoolClass[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    classesApi
      .list()
      .then((result) => setClasses(result.classes))
      .catch((err: unknown) =>
        setError(err instanceof ApiError ? err.message : 'Falha ao carregar.'),
      );
  }, []);

  return (
    <section className="card">
      <div className="card-head">
        <h2>Suas turmas</h2>
        <Link to="/turmas" className="button-link">
          Ver todas
        </Link>
      </div>

      {error && <p className="form-error">{error}</p>}
      {!classes && !error && <p className="muted">Carregando…</p>}

      {classes?.length === 0 && isProfessor && (
        <div className="empty-row">
          <p className="muted">Nenhuma turma criada ainda.</p>
          <Link to="/turmas/nova" className="btn-primary-link">
            Criar turma
          </Link>
        </div>
      )}

      {classes?.length === 0 && !isProfessor && (
        <p className="muted">
          Você ainda não está em nenhuma turma. Use o QR Code que o professor
          compartilhar.
        </p>
      )}

      {classes && classes.length > 0 && (
        <ul className="simple-list">
          {classes.slice(0, 5).map((item) => (
            <li key={item.id}>
              <Link to={`/turmas/${item.id}`}>{item.name}</Link>
              <span className="muted small">
                {item.discipline} · {item.academicTerm}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
